<template>
  <div>
    <OrgList />
  </div>
</template>
<script>
import { TableColumn, Alert } from 'element-ui'

import OrgList from './components/orgList'

import { getActiveOrganizationList, getTradeInfo } from '@/api/activeOrganization'
// import PaginationTable from '@/components/paginationTable'

import ORG_TYPE from '@/utils/orgType'
import Backtop from '@/views/components/backtop'

export default {
  name: 'activeOrganizationList',
  components: {
    // PaginationTable,
    [TableColumn.name]: TableColumn,
    [Backtop.name]: Backtop,
    [Alert.name]: Alert,
    OrgList
  },
  data() {
    return {
      ORG_TYPE,
      orgList: [],
      limit: 20,
      count: 0,
      page: 0,
      keyword: '',
      sort: {},
      defaultSort: { prop: 'orgCreateTime', order: 'descending' },
      orgTypeFilers: ORG_TYPE.getFilterArr(),
      exactMatchArr: [],
      tradeFilters: []
    }
  },
  created() {
    this.handleGetActiveOrgList()
    this.handleGetTradeInfo()
  },
  methods: {
    handleDetail(item) {
      this.$router.push({
        name: 'activeOrganizationDetail',
        query: {
          orgId: item.snId
        }
      })
    },
    handleSeeDtl(item) {
      this.$router.push({
        name: 'whitelistDetail',
        query: {
          orgId: item.snId
        },
        params: {
          isFromActiveOrg: true
        }
      })
    },
    handleGetActiveOrgList() {
      getActiveOrganizationList({
        page: this.page,
        limit: this.limit,
        searchKeyword: this.keyword,
        exactMatchArr: this.exactMatchArr,
        sort: this.sort
      }).then(response => {
        this.orgList = response.data.content.itemArr
        this.count = response.data.content.total
      })
    },
    handleSearchContent(keyword) {
      this.page = 0
      this.keyword = keyword
      this.handleGetActiveOrgList()
    },
    handlePrevClick() {
      this.page--
      this.handleGetActiveOrgList()
    },
    handleNextClick() {
      this.page++
      this.handleGetActiveOrgList()
    },
    handleSizeChange(num) {
      this.limit = num
      this.page = 0
      this.handleGetActiveOrgList()
    },
    handleSortChange(param) {
      this.page = 0
      this.sort = {
        sortField: param.prop,
        direction: param.order === 'ascending' ? 'ASC' : 'DESC'
      }
      this.handleGetActiveOrgList()
    },
    filterHandler(filters) {
      this.exactMatchArr = filters
      this.page = 0
      this.handleGetActiveOrgList()
    },
    handleGetTradeInfo() {
      getTradeInfo().then(response => {
        if (response.data.content && response.data.content.length) {
          this.tradeFilters = response.data.content.map(item => {
            return { text: item.name, value: item.name }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-aol) {
  padding-top: 30px;
  @include e(table-btn) {
    color: $--color-primary;
    cursor: pointer;
  }
  .el-table .cell {
    height: fit-content;
  }
  @include e(desc) {
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
.sky-hc-aol {
  padding-bottom: 30px;
  .el-table__fixed,
  .el-table__fixed-right {
    height: 100% !important;
  }
}
</style>
